import $ from 'jquery';
window.$ = window.jQuery = $;

require('slick-carousel/slick/slick.min');

require('./plugins/iframeResizer.contentWindow.min');
require('./plugins/iframeResizer.min');
require('./plugins/jquery.selectbox.min');
require('./plugins/magnific-popup.min');
require('./plugins/pickajquery');
require('./plugins/svg-modernizr');

/* radiobuttons */
$(document).on('change', '.__radiobuttons input', function(){
    if ($(this).is(':checked')) {
        $(this).closest('.__radiobuttons').find('.input_wrap > label').removeClass('__checked')
        $(this).parent().addClass('__checked');
    }
});
$('.__radiobuttons input:checked').parent().addClass('__checked');


/* checkboxes */
$(document).on('change', '.__checkboxes input', function(){
    if ($(this).is(':checked')) {
        $(this).parent().addClass('__checked');
    } else {
        $(this).parent().removeClass('__checked');
    }
});
$('.__checkboxes input:checked').parent().addClass('__checked');


/* tabpanel */
$(function(){
    var tab = $('.tabpanel-tab');
    var panel = $('.tabpanel-panel');
    var picture = $('.tabpanel-picture');

    tab.eq(0).addClass('__active');
    panel.eq(0).addClass('__active');
    picture.eq(0).addClass('__active');

    tab.click(function(event){
        event.preventDefault();
        tab.removeClass('__active');
        $(this).addClass('__active');
        var data_set = $(this).data('set');
        panel.removeClass('__active');
        panel.filter('[data-set="' + data_set + '"]').addClass('__active');
    });
});


/* accordion */
$(function(){
    var accordion = $('.accordion');
    var title = accordion.find('.accordion-head');
    var content = accordion.find('.accordion-content');

    title.click(function(event){
        event.preventDefault();
        $(this).parents('.accordion').toggleClass('__active');
        $(this).siblings().slideToggle();
    });
});


/* modal */
$(function(){
    var trigger = $('.ModalTrigger');
    var modal = $('.modalblock');
    var close = modal.find('.modalblock-close');

    trigger.click(function(event){
        event.preventDefault();
        var modal_id = $(this).data('modal')
        modal.filter('[data-modal="' + modal_id + '"]').addClass('__active');
    });

    close.click(function(){
        modal.removeClass('__active');
    });

    $(window).click(function(event){
        if(event.target.className == "modalblock __active"){
            modal.removeClass('__active');
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.modablock.__active').removeClass('__active');
        }
    });
});

/*fixed header positioning*/
$(document).ready(function () {
    var windowWidth = $(window).width();
    var searchbar = $('.searchbar');
    var headerheight = $('.mainheaderwrapper').height();

    if(windowWidth >= 992){
        //set pagecontent margin-top to the height of the header so it sits below
        $('.pagecontent').css('margin-top', headerheight);
    }
});


/* searchtoggle */
$(function(){
    var search_toggle = $('.searchtoggle');
    var wrapper = $('.wrapper');
    var mobilesearch = $('.searchbar.__mobile');
    var closebutton = $('.searchbar-exit');
    var searchbar = $('.searchbar');
    var windowWidth = $(window).width();
    var searchbarHeight = $(searchbar).height();
    var headerheight = $('.mainheaderwrapper').height();

    $(this).toggleClass('__active');
    wrapper.toggleClass('__searchactive');
    $('.pagecontent').css('margin-top', headerheight);

    search_toggle.click(function(event){
        event.preventDefault();
        $(this).toggleClass('__active');
        wrapper.toggleClass('__searchactive');

        if (wrapper.hasClass('__searchactive')) {
            $('#SearchInput').focus();
        }

        if(windowWidth >= 992){
            searchbar.toggleClass('__active');
        }
        else{
            mobilesearch.toggleClass('__active');
        }
    });

    closebutton.click(function(){
        wrapper.toggleClass('__searchactive');
        if(windowWidth >= 992){
            searchbar.toggleClass('__active');
            $('.pagecontent').css('margin-top', headerheight);
        }
    })
});

/* Main Menu */
$(function(){

    var body =  $('body');
    var nav = $('.nav');
    var burger =  $('.burger');
    var nav_trigger =  $('.nav').find('ul li');
    var nav_align = 'right';
    var break_point =  992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    // var nav_window = $('<div class="navwindow"></div>');
    // body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var nav_close = $('.navclose');


    // nav_window.click(function(event){
    //     nav_reset();
    // });

    //burger click
    burger.click(function(event){
        event.preventDefault();
        $(this).toggleClass('__active');
        if(body.hasClass('__mobile')){
            nav_reset();
        }else{
            nav_launch();
        };
    });

    nav_close.click(function(){
        nav_wrap.removeClass('__active');
        burger.removeClass('__active');
        body.removeClass('__mobile');
        // nav_window.hide();
        nav_wrap.find('ul').removeClass('__active');
    });

    /*nav reset*/
    var nav_reset = function nav_reset(){
        burger.removeClass('__active');
        // nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch(){
        // nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    if(browser_width < break_point){
        nav_trigger.click(function(event){
            event.stopPropagation();
            if($(this).children('ul').length > 0){
                event.preventDefault();
                $(this).parents('ul').removeClass('__active');
                $(this).children('ul').addClass('__active');
            };
        });
    };

    var nav_ul = $('.nav ul li > ul');
    var view_button = $('<li class="viewall"><a href="#">View</a></li>');
    var back_button = $('<li class="backto"><a href="#">Back</a></li>');

    if(browser_width < break_point){
        nav_ul.prepend(view_button);
        nav_ul.prepend(back_button);
    };

    var back_menu = $('.backto');
    back_menu.click(function(event){
        event.preventDefault();
        event.stopPropagation();
        $(this).parent('ul').removeClass('__active');
        $(this).parents('li').parent('ul').addClass('__active');
    });

    var view_all = $('.viewall');
    view_all.each(function(){
        var parent_url = $(this).closest('ul').siblings().attr('href');
        var parent_title = $(this).closest('ul').siblings().html();
        $(this).find('a').attr('href', parent_url);
        $(this).find('a').html('View ' + parent_title);
    });

    view_all.click(function(event){
        event.stopPropagation();
    });

});


/* sidemenu */
$(function(){
    var toggle = $('.sidemenu-toggle');
    toggle.click(function(event){
        event.preventDefault();
        $(this).parent().toggleClass('__active');
        $(this).siblings().slideToggle();
    });
});


/* ScrollTo */
(function(){
    $.fn.scrollto = function(options) {
        var settings = $.extend({
            trigger: '#ScrollTo',
            scroll_to: '.wrapper',
            speed: 1000,
        }, options);
        $(settings.trigger).click(function(event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $(settings.scroll_to).offset().top,
            }, settings.speed);
        });
    }
})();
$('#ScrollTo').scrollto({
    trigger: '#ScrollTo',
    scroll_to: '.wrapper',
    speed: 1000,
});




/*share*/
$(function(){
    // var share_toggle = $('.shareitem-trigger');
    var share_toggle = $('.shareitem');
    share_toggle.hover(function(){
        $(this).find('.shareitem-icons').toggleClass('__active');
      },function() {
        $(this).find('.shareitem-icons').removeClass('__active');
      }
    );
});


/* share social */
$(function(){
    var toggle = $('.socialshare-title');
    var shareicons = $('.socialshare-socialset');

    toggle.click(function(event){
        event.preventDefault();
        $(this).siblings('.socialshare-socialset').toggleClass('__active');
    });

});

function setblockHeight(){
    var tallest = 0;

    $(".resourceitem").each(function () {
        if ($(this).outerHeight() > tallest) {
            tallest = $(this).outerHeight();
        }
    });

    $(".resourceitem").outerHeight(tallest);
}

$(document).ready(function () {
    setblockHeight();
});

$(document).ready(function () {
    $('table').wrap('<div class="table-wrap"><div>');
});

$(document).ready(function () {
    var tallest = 0;

    $(".listitem").each(function () {
        if ($(this).outerHeight() > tallest) {
            tallest = $(this).outerHeight();
        }
    });

    $(".listitem").outerHeight(tallest);
});


$(document).ready(function () {
    var menuitems = $('#menu-main-menu > li');
    menuitems.each(function(i, item){
        if(i == menuitems.length -1 || i == menuitems.length -2 || i == menuitems.length -3){
            $(this).addClass("__last");
        }
    })
});


var breadcrumb = $('.breadcrumb');
var breadcrumboffset = 0;
var breadcrumbheight = 0;
if (breadcrumb.length) {
    breadcrumboffset = breadcrumb.offset().top;
    breadcrumbheight = breadcrumb.outerHeight();
}

// textpage - sticky sidemenu
$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if($(window).width() < 992){
        var headerheight = $('.header').outerHeight();
    }
    else{
        var headerheight = $('.header').outerHeight() + $('.topheader').outerHeight();
    }

    if (scroll > breadcrumboffset && !breadcrumb.hasClass('__fixed')) {
        breadcrumb.addClass("__fixed");
        breadcrumb.css("top", headerheight);
        $('.pagecontent').css('margin-top', headerheight + breadcrumbheight);
    }
    else if(scroll < breadcrumboffset){
        breadcrumb.removeClass("__fixed");
    }
});
